import { Link } from "@remix-run/react";
import { motion } from "framer-motion";

import { CoverImage } from "~/components/blog/cover-image";
import { Date } from "~/components/blog/date";
import { HorizontalSeparator } from "~/components/blog/horizontal-separator";
import { item } from "~/components/site/layout";
import type { Post } from "~/lib/post";

type Props = Readonly<{
  post: Post;
  readingTime: string;
}>;

export function PostCard({ post, readingTime }: Props): JSX.Element {
  return (
    <motion.div variants={item}>
      <Link
        prefetch="intent"
        to={`/blog/${post.slug}`}
        className="font-semibold no-underline grid grid-col-1 md:grid-cols-2 lg:grid-cols-1 md:items-center md:gap-x-8 m-0"
      >
        {post.coverImage ? (
          <CoverImage
            image={post.coverImage}
            link={post.coverImage.link}
            className="round border border-primary"
          />
        ) : (
          <img
            src="/assets/site/cover-image-default.svg"
            alt=""
            className="round border border-primary"
          />
        )}
        <div className="flex flex-col gap-y-4 pt-6 md:pt-0 lg:pt-8 prose dark:prose-invert">
          <h4 className="m-0 text-xl">{post.title}</h4>
          <div className="flex flex-row items-center gap-x-4 md:gap-x-6 font-normal">
            <Date dateString={post.date} />
            <HorizontalSeparator />
            <div className="whitespace-nowrap">
              {post.timeOverride
                ? `${post.timeOverride} min read`
                : readingTime}
            </div>
          </div>
          <div className="blurb font-normal block md:hidden lg:block">
            {post.excerpt}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
